import * as React from 'react'
import { Box } from '@mui/material'
import { translateCountryName } from "@ui-seeker/utils"

import { LabelCountry } from '@components'


export default function retailerColumn() {
    return [{
		name: 'country', label: 'Country',
		options: {
			display: 'excluded',
			customBodyRowRender: v => translateCountryName(v)
		}
	},{
        name: 'retailer', label: 'Retailer',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value, { country, siteURL }) => <Box>
				<LabelCountry label={value} siteUrl={siteURL} country={country} />
			</Box>
        }
    }]
}